import React, { useMemo } from "react";
import { Box, Button, Card, Chip, Grid, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TbCongruentTo } from "react-icons/tb";
import { overviewChartPalette } from "styles/theme";

const VendorWiseInvoice = () => {

    const categories = [
        "GRIL",
        "Gleeds",
        "Consultant-1",
        "Contractor-1",
        "Contractor-2",
    ];

    // Dummy data – tweak to match your real values
    const rejected = [5, 10, 6, 7, 9];
    const withheld = [3, 5, 3, 5, 4];
    const approved = [60, 80, 75, 45, 61];

    const options = {
        chart: {
            type: "bar",
            height: 380,
            spacingLeft: 0,
            spacingRight: 40,
        },
        title: { text: "" },
        xAxis: {
            categories,
            lineWidth: 0,
            tickWidth: 0,
            labels: {
                style: {
                    fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont",
                    fontSize: "12px",
                    color: "#4b5563",
                    fontWeight: 500,
                },
            },
        },
        yAxis: {
            min: 0,
            title: { text: null },
            gridLineWidth: 0,
            labels: {
                enabled: false,
            },
        },
        legend: { enabled: true }, // you can make a separate legend like your design
        tooltip: {
            shared: true,
            // valueSuffix: " INR",
        },
        plotOptions: {
            series: {
                stacking: "normal",
                pointPadding: 0.25,
                borderRadius: 3,
                borderWidth: 0,
                dataLabels: {
                    enabled: true,

                },
            },
            bar:{
                dataLabels: {
                    enabled: true
                },
            }
        },
        credits: { enabled: false },
        series: [
            {
                name: "Rejected",
                data: rejected,
                color: overviewChartPalette.coral,
                    dataLabels: {
                    // show end label on the blue segment (right side)
                        enabled: true,
                        align: "right",
                        inside: false,
                    style: {
                        fontWeight: 500,
                        color: "#4b5563",
                        textOutline: "none",
                        fontSize: "12px",
                    },
                    formatter: function () {
                        // stackTotal is full bar; we want right-side value text
                        const total =
                            (this.point.stackTotal ?? 0).toLocaleString("en-IN");
                        return total;
                    },
                },
            },
            {
                name: "Withheld",
                data: withheld,
                color: overviewChartPalette.amber,
            },
            {
                name: "Approved",
                data: approved,
                color: overviewChartPalette.teal,
            },
        ],
    };

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 3,
                border: "1px solid #E4E4E4",
                width: '100%',
            }}
        >
            <Box sx={{
                width: '100%',
                borderBottom: "1px solid #E4E4E4",
                p: 1.5,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '20px',
                        letterSpacing: "0px",
                        mb: 0
                    }}>
                        Vendor Invoice Position
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                        fontSize: '16px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}>
                        Compare approved, withheld, and rejected invoice value across vendors.
                    </Typography>
                </Box>
            </Box>
            <Grid contaier sx={{ p: 1.5 }}>
                <Grid size={12}>
                    <HighchartsReact highcharts={Highcharts} options={options} />
                </Grid>
            </Grid>
        </Card>
    );
};

export default VendorWiseInvoice;
